import { useTranslation } from "react-i18next";
import { useProblemsForSiteLevelType } from "../reducers/problemSlice";
import useClientConfig from "../common/hooks/clientConfigHook";
import TypeaheadInput from "../common/components/TypeaheadInput";
import { useCallback, useMemo } from "react";
import { distinct } from "../common/utils/arrayUtilities";
import { propagateFields } from "./customCtrlUtils";

export const customCtrlDef = {
    control: ({ def, onChange, site, level, type, problem, priority, context: { args } = {}, ...props }) =>
        <ProblemInput site={site ?? args?.site ?? def.site} level={level ?? args?.level ?? def.level} type={type ?? args?.type ?? def.typeParam} problem={problem ?? args?.problem ?? def.problem} priority={priority} onChange={value => propagateFields(value, def.strict ? def.field : ['problem'], onChange)} wildcard={def.wildcard} {...props}></ProblemInput>
}

const ProblemInput = ({ id, site, type, level, priority, problem, placeholder, disabled, required, onChange, hideLabel, readonly, wildcard, live }) => {
    const clientConfig = useClientConfig();
    const { t } = useTranslation();
    const problems =  useProblemsForSiteLevelType(site, level, type);

    const handleChange = useCallback(p => {
        let update = { problem: p };
        let matches = problems.filter(prob => prob.problem === p);
        if (matches?.length > 0) {
            const sites = distinct(matches.map(m => m.site));
            if (sites.length === 1 && sites[0] && sites[0] !== site) {
                update.site = sites[0];
            }
            const levels = distinct(matches.map(m => m.level));
            if (levels.length === 1 && levels[0] && levels[0] !== level) {
                update.level = levels[0];
            }
            const types = distinct(matches.map(m => m.type));
            if (types.length === 1 && types[0] && types[0] !== type) {
                update.type = types[0];
            }
            const priorities = distinct(matches.map(m => m.priority));
            if (priorities.length === 1 && priorities[0] && priorities[0] !== priority) {
                update.priority = priorities[0];
            }
            const assistance = distinct(matches.map(m => JSON.stringify(m.assistance)));
            if (assistance.length > 0 && assistance[0]) {
                update.assistance = JSON.parse(assistance[0]);
            }
        }
        onChange(update);
    }, [site, level, type, priority, problems, onChange]);

    const options = useMemo(() => problems.map(p => p.problem), [problems]);

    return <TypeaheadInput id={id ?? "problemInput"} live={live} options={options} value={problem} placeholder={(placeholder ?? t('problem', { count: 1 }))} wildcard={wildcard}
        disabled={disabled} required={required} readonly={readonly} lockdown={clientConfig.lockdownProblems} onChange={handleChange} hideLabel={hideLabel}></TypeaheadInput>;
}

export default ProblemInput;